import { TChartSeriesType } from "./types";

/*
const COLORS_LIST = [
  '#00A9A3',
  '#AB1F77',
  '#C0DE27',
  '#4472C4',
  '#FFC805',
  '#52A40B',
  '#4C5155',
  '#F58F00',
  '#5DADE2',
  '#795548',
  '#EF5350',
  '#546E7A'
];
*/
export const COLORS_LIST = [
  "#444444",
  "#00A9A3",
  "#AB1F77",
  "#C0DE27",
  "#4472C4",
  "#FFC805",
  "#52A40B",
  "#4C5155",
  "#F58F00",
  "#5DADE2",
  "#795548",
  "#EF5350",
  "#546E7A",
];
export const seriesColors = COLORS_LIST.map((color) => ({
  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
  stops: [
    [0, `${color}80`],
    [1, color],
  ],
}));
export const getChartStyles = (selectedSeries?: TChartSeriesType) => {
  // const rtl = useAppContext((s) => s.rtl);
  const rtl = false;
  const chartStyles = {
    bar: {
      borderRadius: (selectedSeries && selectedSeries.length * 0.3) || 5,
      color: seriesColors[0],
      shadow: {
        color: "rgba(0,0,0,0)",
        width: 15,
        offsetX: 15,
      },
      dataLabels: {
        enabled: true,
        color: "rgb(93,98,104)",
        padding: 0,
        formatter: function (this: any) {
          return this.point?.options?.formattedPoint;
        },
      },
    },
    column: {
      borderRadius: (selectedSeries && selectedSeries.length * 0.3) || 5,
      color: seriesColors[0],
      shadow: {
        color: "rgba(0,0,0,0)",
        width: 15,
        offsetY: 15,
      },
      dataLabels: {
        enabled: true,
        color: "rgb(93,98,104)",
        padding: 0,
        formatter: function (this: any) {
          return this.point?.options?.formattedPoint;
        },
      },
    },
    pie: {
      animation: false,
      dataLabels: {
        enabled: true,
        formatter: function (this: any) {
          return rtl
            ? `,${this.point?.options?.formattedPoint}:<b>‪${
                this.point.name
              } <br/>
          %‪${this.point.percentage.toFixed(2)}</b>`
            : `<b>${this.point.name}</b>:${
                this.point?.options?.formattedPoint
              }, <br/> ${this.point.percentage.toFixed(2)}%`;
        },
      },
      showInLegend: true,
      innerSize: "0%",
      center: ["50%", "50%"],
    },
    donut: {
      animation: false,
      dataLabels: {
        enabled: true,
        formatter: function (this: any) {
          return rtl
            ? `,${this.point?.options?.formattedPoint}:<b>‪${
                this.point.name
              } <br/>
          %‪${this.point.percentage.toFixed(2)}</b>`
            : `<b>${this.point.name}</b>:${
                this.point?.options?.formattedPoint
              }, <br/> ${this.point.percentage.toFixed(2)}%`;
        },
      },
      tooltip: {
        formatter: function (this: any) {
          return `<b>${this.point.name}</b>:${
            this.point?.options?.formattedPoint
          }, <br/> ${this.point.percentage.toFixed(2)}%`;
        },
      },
      showInLegend: true,
      innerSize: "70%",
      center: ["50%", "50%"],
    },
    spline: {
      color: "rgb(93,98,104)",
      lineWidth: 5,
      shadow: {
        color: "rgba(0,0,0,0.1)",
        width: 15,
        offsetY: 15,
      },
      plotOptions: {
        series: { connectNulls: true },
      },
      marker: {
        enabled: true,
        // see: https://api.highcharts.com/highcharts/plotOptions.series.marker
        // url(graphic.png)
        symbol: "circle",
        fillColor: "#FFFFFF",
        lineColor: "rgb(93,98,104)",
        lineWidth: 3,
        radius: 13,
        states: {
          hover: {
            enabled: true,
            radius: 10,
          },
        },
      },
      dataLabels: {
        enabled: true,
        color: "rgb(93,98,104)",
        padding: 0,
        formatter: function (this: any) {
          return this.point?.options?.formattedPoint;
        },
      },
    },
    areaspline: {
      lineWidth: 5,
      marker: {
        enabled: true,
        symbol: "circle",
        fillColor: "#FFFFFF",
        lineColor: "rgba(59,187,183)",
        lineWidth: 3,
        radius: 10,
        states: {
          hover: {
            enabled: true,
            radius: 10,
          },
        },
      },
      shadow: false,
      states: {
        hover: {
          lineWidth: 5,
        },
      },
      dataLabels: {
        enabled: true,
        color: "rgba(59,187,183)",
        padding: 0,
        formatter: function (this: any) {
          return this.point?.options?.formattedPoint;
        },
      },
    },
  };
  return chartStyles;
};
